module.exports = __webpack_public_path__ + "static/formTestimonials-57572b9f24b1afe30eb84eaff6b78571.jpg";